<template>
  <div>
  <!-- <div v-pre 
    p:await='console.error(e.nonce,#wait)||false'
    b:500='#wait'
    b:wait='#wait'
    p:_value='s ? #wait = s : #wait + @value'
    v:value:wait='s ? #wait = e.value : #wait'
    v:value:phone='#wait'
    v:model:phone='#wait'
    v-model='wait.last.zyly'
    z-value='#wait'
    z-checked=''
    z-inner-text=''
    z:_inner-text='#count++'
    z:set='console.error(8888)'
    o:click:once:500.1:active:250='alert(#last),console.error(E,arguments),e._innerText=88888' 
    >
    
    <input type="text" o::input:phone='E.type ? #wait = e.value : e.value = #wait, console.error(E)' >
    <div z-for="forArr(#array,(item,index),'*')::only" xz-for=':{:state,:goodId},index in #object' z-for='of #object' e.__to__={e,__to__:{}} >
      <span >`#last`</span>
      <span >`lastly: ${#last} 哈哈哈哈 ${@item + to.item + to.item + t.host }`</span> e, o, t:e.__to__, s, to:e.__to__.to
      <span s:color="#last ? 'red' : 'blue'">测试前端</span>
      <a href="" z-for='value,key in #numbers' >``${ @item.goodId + '' + @index + @textInfo } ("textInfo" in to ? to : t).textInfo 哈哈哈`</a>
    </div>

    zForElement.__to__ = {
      __proto__: null,
      host: zForElement,
      to: {
        value: {},
        key: 0,
        textInfo: "哈哈哈哈",

        to: zForElement.__to__ = {
          __proto__: null,
          to: {
            item: { },
            index: 0,
            goodId: 777
          }
        },

      }
    };


    for( var i = 0; ; ) const {state,goodId} = item;
    ``#last + 6666666` -->

    <!-- </div> -->
    <!-- <videoupload
      v-event.*preview='`(filelist = typeof a === "string" ? a : a[0] || a, title = b ===void 0 ? null : b, boolean=true)`'
      type='fixed'
      readonly
      selfpreview="selfpreview"
      :title=' title || 35'
      show='boolean'
      height='auto'
      dialogstyle='margin-top: 50px;'

      :filelist='filelist'
      @click-mask='hide=>hide()'

      x:filelist='/static/favicon.png'
      update:show='(info,comp)=>{}'
      close='boolean=false'
      >
    </videoupload> -->
  </div>
</template>

<script >

export default {
  data() {
    return {
      filelist: '',
      title: '',
    };
  },

  watch: {

  },

  methods: {


  },

  mounted() {
    // console.error(this.$el);
    const document = window.document; // .documentElement;
    if( !document.PreviewVideo ) {
      const html = document.documentElement; let box, video, img, closel;
      html.insertAdjacentHTML(
          'beforeEnd',
          `
          <div id=PreviewVideo style="">
            <video src="" controls autoplay width=100% height=100%></video>
            <i class=el-icon-close title=关闭><i class="el-icon-close" style="position:absolute;width:25px;left:17px;bottom:16px;"></i></i>
            <i class=el-icon-edit title=修改视频封面 style="top:-150px;left:-150px;right:auto;color:var(--Colorlight);visibility:hidden;" >
              <i class="el-icon-edit" style="position:absolute;width: 25px;right: 25px;left: auto;font-size: 30px;bottom: 20px;"></i>
            </i>
            <img src="" width=100% height=100% >
          </div>
          `
      );
      if( ( box = html.lastElementChild ).id !== 'PreviewVideo' ) box = box.firstElementChild;
      ( closel = box.children[1] ).onclick = function(){
        var box, { video, editel } = box = this.parentElement;
        ( editel = editel.style ).top === '' && ( editel.left = editel.top = '-150px' );
        video.pause();
        box.img.style.transform = '';
        box.style.transform = '';
      };

      box.onclick = function(event){
        // console.warn(77777777, event, this);
        if( event.target === this && ( event = this.img ).style.top === '0px' ) {
          !event.style.transform  // height !== 'auto'
          ? (
            this.video.pause(),
            event = this.editel.style,
            event.top === '' && ( event.left = event.top = '-150px' ),
            box.img.style.transform = '',
            this.style.transform = ''
          )
          : event.click();
        };
      };

      box.onmousewheel = function(event){
        // console.warn(event);
        const img = this.img, imgstyle = img.style;
        if( imgstyle.top !== '0px' ) return;
        // imgstyle.width = img.width + 'px', imgstyle.height = 'auto';

        const up = event.wheelDeltaY ? event.wheelDeltaY > 0 : event.detail < 0;
        const step = !sleep.clear(49.37136161111) 
          ? this.__step__ = 0.1 // 100
          : this.__step__ += ( up ? 0.2 : 0.05 ); // ( event.wheelDeltaY > 0 ? 110 : 80 );
        
        // console.warn(step);
        sleep(49.37136161111);

        imgstyle.transform = `translateX(-50%) scale(${ 
          ( imgstyle.transform.replace('translateX(-50%) scale(','').slice(0,-1) * 1 || 1 ) + ( up ? step : -step )
        })`;
        // imgstyle.width = event.wheelDeltaY > 0  // 向上滚动
        // ? ( img.width += step ) + 'px'
        // : ( img.width -= step ) + 'px';
      };
      box.addEventListener('DOMMouseScroll',box.onmousewheel,false);

      ( img = box.lastElementChild ).onclick = function(){
        if( this.style.transform ) { // height === 'auto'
          // this.style.height = this.height + 'px';
          this.style.transform = '';
          // window.setTimeout( v=>this.style.width = this.style.height = '', 100 );
        };
      };

      //  /\.(mp4|mov|avi|m4v)$/i
      const PreviewVideo = document.PreviewVideo = function(url,type,callback) {
        var html = this.documentElement, box = this.PreviewVideo.el, { video, img, editel } = box;
        if( arguments.length === 0 ) {
          video.pause();
          ( editel = editel.style ).top === '' && ( editel.left = editel.top = '-150px' );
          box.style.transform = 'none';
          return;
        };
        // console.warn(url,type);
        url = typeof url === 'object' ? url[0] || url : url || '';
        if( type && Array.isArray(type) 
          || (type||'').startsWith('image')
          || url.search( box.__regvideo__ || ( box.__regvideo__ = /\.(mp4|mov|avi|m4v|mkv)$/i ) ) === -1 && !url.startsWith('blob:')
        ) {
          box.style.transform = "none";
          video.pause(), video.style.pointerEvents = 'none', video.style.opacity = img.style.top = '0';
          img.style.width = img.style.height = '', img.src = url;
          const style = editel.style;
          if( type === 'image:edit' ) {
            if( style.top !== '' ) setTimeout(()=>{style.top = style.visibility = '', style.left = '-62px';},300);
            if( callback ) {
              editel.__callback__ = callback;
              editel.onclick = async function(event){
                if( this.__callback__ ) {
                  event = await this.__callback__(event);
                  // console.error(5555555555,event);
                  event === false && document.PreviewVideo();
                  return;
                };
                // this.onclick = null
              };
            };
          } else if( style.top === '' ) {
            editel.__callback__ = null;
            style.top = style.left = '-150px', style.visibility = 'hidden';
          };
          return;
        };

        video.style.opacity === '0' && ( 
          video.style.opacity = '1',
          video.style.pointerEvents = '',
          img.style.top = '101%',
          editel.__callback__ = null,
          ( editel = editel.style ).top = editel.left = '-150px'
        );
        video.src !== url
        ? video.src = url
        : video.play();
        return box.style.transform = "none";
      };

      box.__step__ = 100, box.__regvideo__ = false, box.editel = box.children[2];

      PreviewVideo.el = box,
      PreviewVideo.img = box.img = img, 
      PreviewVideo.closel = box.closel = closel,
      PreviewVideo.video = box.video = box.firstElementChild;
    };

  },

  /*activated() {
    if( window.Appload === "mounted" ) {
      window.location.reload(true);
    };
  },

  beforeUpdate() {
    console.warn('更新之前....');
    if( window.Appload === "mounted" ) {
      window.location.reload(true);
    };
  },

  updated( ) {
    console.warn('更新完成....');
  },

  beforeDestory(){
    console.warn("销毁前：");
  },*/

  created2() {
    // console.error(88888888899999999, Appload);
    /*if( window.Appload === "mounted" ) {
      window.location.reload(true);
    };*/
    // done( bool="刷新成功!", time=350:自动隐藏上拉箭头和信息的延时);
    // done(true,1)                        -> 下拉刷新成功+取消上拉加载+阻止自动隐藏"刷新成功!";
    // done("加载成功",250)                -> 显示 "加载成功", 然后 停留250ms 消失
    // done("加载失败,请检查网络！",-1500) -> 时间time < 0, 代表的失败后的延时, 会自动显示 失败信息 + 失败图标 Z.iconError (=默认有一个,但还可以自定义...icon)

    /*`
      View.ready({
        zScroll: {
          default: 'white',
          down( done, Z ) {
            Z.iconError="../icon/icon_roundreduce.png";
            done.sleep(3000,"加载失败,请检查网络！",-1500);
          },
          up(done,Z) {
            setTimeout(()=>{
              console.error(done,this);
              this.C = ( this.C || 0 ) + 40;
              done();
              // done(false);
              // done(this.C = 0);
            },500);
          }
        }
      });
    `;

    `
      如果配置了 行内zScroll, 那么优先采用 并触发 行内zScroll 的下拉刷新函数
      否则 解析 zScroll 对象的配置
    `;

    ` z-scroll=' Z.iconError="../icon/icon_roundreduce.png"; done.sleep(3000,"加载失败,请检查网络！",-1500); ' `;

    this.View.zScroll = {
      default: 'white2',
      font: '#353535 14px',
      // iconLoading: './img/loading.gif',
      // background: '#f8f8f8 url(./img/loading.png) no-repeat',
      background: '#f8f8f8',
      time: '',
      // icon: [ 'icon-up', '下拉刷新', '松开后立即刷新' ],
      down(done,Z) {
        // console.error(done);
        setTimeout(()=>{
          this.C = 40;
          done(true,1);
        },2000);
      },
      auto: true,
      right: 20,
      aiconTop: './img/up.png',
      acolorTop: 'rgba(250,0,0,.15)',
      iTop: 500,
      up(done,Z) {
        setTimeout(()=>{
          // console.error(done,this);
          this.C = ( this.C || 0 ) + 40;
          done();
          // done(false);
          // done(this.C = 0);
        },500);
      }
    };*/


  },

};

</script>

<style xscoped >
  
  #PreviewVideo {
    position:fixed;
    left:0;
    top:0;
    width:100%;
    height:100%;
    z-index: 9999999999999999999;
    z-index: 10000000000000000000;
    z-index:100000000000000000000;
    background:radial-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.9));
    transform: scale(0.5) translateY(150%);
    transition: all 200ms ease;
  }
  #PreviewVideo[style=""] > .el-icon-close {
    visibility: hidden;
  }
  #PreviewVideo > video, #PreviewVideo > img {
    opacity: 1;
    transition: all 250ms ease;
  }
  #PreviewVideo > img {
    object-fit: contain;
    position: absolute;
    left: 0;
    top: 101%;
    z-index: 77;

    /* width: auto; */
    left: 50%;
    transform: translateX(-50%);
    /* object-fit: none; */
  }

  #PreviewVideo > i {
    position: absolute;
    z-index: 9999;
    font-size: 40px;
    right: 35px;
    top: 35px;
    color: #e92f2f;
    background: rgba(255,255,255,0.6);
    border-radius: 100%;
    padding: 10px;
    cursor: pointer;
    transition: all 300ms ease;
    /*transform: translateY(0%);*/
    right: -62px;
    top: -60px;
    padding: 40px;
  }
  #PreviewVideo > i:before {
    opacity: 0!important;
  }
  #PreviewVideo > i:hover {
    background: rgba(255,255,255,0.75)!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/$Preview.local.vue